module.exports = __webpack_public_path__ + "media/kanjiannideshengyin.66b5ce8c.mp3";